import Link from 'next/link';
import React from 'react';
import LargeWidthContainer from '../Layout/Containers/LargeWidthContainer';
import { StrapiImageComponent } from '../util/MediaComponent/MediaComponent';
import { Resource } from '../Models/ResourceProps';
import styles from './customerCases.module.scss';

type CustomerCasesProps = {
    works: Array<Resource>;
};

const CustomerCasesComponent = ({ works }: CustomerCasesProps) =>
    works.length > 0 ? (
        <LargeWidthContainer>
            <section className={styles.customerCases}>
                <div className={styles.header}>
                    <div>
                        <span className={styles.eyebrow}>Customer cases</span>
                        <h2 className={styles.title}>Specialist insurers running live.</h2>
                    </div>
                    <Link href="/resources?type=CUSTOMER_STORIES" className={styles.all}>
                        <span>All cases</span>
                        <span aria-hidden="true">&rarr;</span>
                    </Link>
                </div>
                <div className={styles.grid}>
                    {works.map((work) => (
                        <Link
                            key={`noria-work-${work.seoUrl}`}
                            href={`/resources/${work.seoUrl}`}
                            className={styles.card}
                            title={`Go to resource page for ${work.heading}`}
                        >
                            <StrapiImageComponent
                                className={styles.imageWrapper}
                                strapiImage={work.mainImage}
                            />
                            {work.punchline && <p className={styles.tags}>{work.punchline}</p>}
                            <h3 className={styles.name}>{work.heading}</h3>
                            <p className={styles.description}>{work.ingress}</p>
                        </Link>
                    ))}
                </div>
            </section>
        </LargeWidthContainer>
    ) : null;

export default CustomerCasesComponent;
